module.exports = __webpack_public_path__ + "static/media/Apple Music.be7e04c6.png";